import { render, staticRenderFns } from "./BpHeader.vue?vue&type=template&id=1ec471f8&"
import script from "./BpHeader.vue?vue&type=script&lang=js&"
export * from "./BpHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports